let theme = {
  primary: '#1465FF',
  secondary: '#14A0FF',
  third: '#576573',
  four: '#1B3055',
  five: '#C2EAFF'
}

export default theme
